import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from '../../common/withRouter';
import { Loader, ButtonOBSOLETED } from "../../web.common";
import {
    Filters,
    FilterInput,
} from "./Filters";
import { getQueryStringParameters } from "../../common/utils";
import { DisplayGuid } from "../items";
import { LayoutContext } from "../layout/siteLayout";
import PageTop from "../layout/PageTop";
import withApi from "../higherOrderComponents/withApi";

const ProviderAdminInternal = (props) => {
    const [loadedData, setLoadedData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const navigationButtonStyle = {
        width: "6%",
        color: "grey",
        fontSize: "0.85rem",
    };

    const clickable = {
        cursor: "pointer",
    };

    useEffect(() => {
        async function loadFromApi() {
            loadData()
        }
        if (!loadedData) {
            loadFromApi();
        }
    }, []);

    const loadData = async () => {
        setIsLoading(false);
        const { history, location } = props;
        const filters = getQueryStringParameters(location.search);
        const data = await props.api.providerAdmin.getProviderAdmins({
            filters,
        });

        setLoadedData(data);

        setIsLoading(true);
    };

    const filters = getQueryStringParameters(props.location.search);
    const page = parseInt(filters.page) || 1;
    const orderBy = filters.orderBy || "createdDate";
    const orderDirection = filters.orderDirection || "desc";

    const orderHandler = (name) => {
        const { history, location } = props;
        let direction;
        if (name.toLowerCase() === orderBy.toLowerCase()) {
            direction = orderDirection === "desc" ? "asc" : "desc";
        } else {
            direction = "desc";
        }

        Filters.goToPage(history, location, page, name, direction);
    };

    const pagingHandler = async (action) => {
        const { history, location } = props;

        if (page < loadedData.data.pageCount && action === "add") {
            Filters.goToPage(history, location, page + 1, orderBy, orderDirection);
        }
        if (page > 1 && action === "sub") {
            Filters.goToPage(history, location, page - 1, orderBy, orderDirection);
        }
    };

    const header = [
        {
            name: "ProviderAdminId",
            label: "ProviderAdminId",
            canOrder: false,
            render: ({ providerAdminId }) => <DisplayGuid>{providerAdminId}</DisplayGuid>,
        },
        {
            name: "UserEmail",
            label: "UserEmail",
            canOrder: false,
            render: ({ email }) => <span>{email}</span>,
        },
        {
            name: "Provider Name",
            label: "Provider Name",
            canOrder: false,
            render: ({ providers }) => {
                if (providers.length === 0) return <span></span>;
                return (
                    <span>
                        {providers.slice(0,3).map((provider, index) => (
                            <React.Fragment key={provider.providerId}>
                                {index > 0 && ", "}
                                {provider.providerName}
                            </React.Fragment>
                        ))}
                        {providers.length > 3 && " ....."}
                    </span>
                );
            },
        }, ,
        {
            name: "Facility Name",
            label: "Facility Name",
            canOrder: false,
            render: ({ facilities }) => {
                if (facilities.length === 0) return <span></span>; 
                return (
                    <span>
                        {facilities.slice(0,3).map((facility, index) => (
                            <React.Fragment key={facility.facilityId}>
                                {index > 0 && ", "}
                                {facility.facilityName}
                            </React.Fragment>
                        ))}
                        {facilities.length > 3 && " ....."}
                    </span>
                );
            },
        },
    ];

    return (
        <LayoutContext.Consumer>
            {() => (
                <React.Fragment>
                    <div className="content-with-right-pane-delimiter">
                        <PageTop
                            documentTitle="Provider Admin"
                            documentDescription="Provider Admin"
                        />
                        <h2 className="main-page-header">
                            Provider Admin
                        </h2>
                        <Filters
                            initFromUrl
                            submitUrl
                            validateForm={(
                                {
                                    id,
                                    user,
                                    facilityId,
                                    providerId,
                                    resultsPerPage,
                                    providerOrFacility
                                },
                                updatedKey
                            ) => {
                                if (updatedKey !== "id") {
                                    return {
                                        id,
                                        user,
                                        facilityId,
                                        providerId,
                                        resultsPerPage,
                                        providerOrFacility
                                    };
                                }
                                return { id };
                            }}
                            render={(formData, update) => (
                                <div className="filters-block">
                                    <div className="filters-label-block">
                                        <label className="filters-label" htmlFor="id">
                                            Provider Admin Id
                                        </label>
                                        <FilterInput
                                            data={formData}
                                            update={update}
                                            name="id"
                                            placeholder="Find by id"
                                        />
                                    </div>
                                    <div className="filters-label-block">
                                        <label className="filters-label" htmlFor="signupId">
                                            User
                                        </label>
                                        <FilterInput
                                            data={formData}
                                            update={update}
                                            name="user"
                                            placeholder="Find by user id"
                                        />
                                    </div>
                                    <div className="filters-label-block">
                                        <label className="filters-label" htmlFor="resultsPerPage">
                                            Results Per Page
                                        </label>
                                        <FilterInput
                                            data={formData}
                                            update={update}
                                            name="resultsPerPage"
                                            placeholder="insert number of result to show per page"
                                        />
                                    </div>
                                    <div className="filters-label-block">
                                        <label className="filters-label" htmlFor="resultsPerPage">
                                            Provider or Facility
                                        </label>
                                        <FilterInput
                                            data={formData}
                                            update={update}
                                            name="providerOrFacility"
                                            placeholder="search by provider or facility"
                                        />
                                    </div>
                                    <br />
                                    <br />
                                    <div className="filters-submit-wrapper">
                                        <ButtonOBSOLETED
                                            type="submit"
                                            buttonContent="Search"
                                            disabled={!isLoading}
                                        />
                                    </div>
                                    <hr />
                                </div>
                            )}
                        />
                        {loadedData == null ? (
                            <Loader hasLoaded={false} />
                        ) : (
                            <>
                                <div
                                    style={{ display: "flex", justifyContent: "space-between" }}
                                >
                                    <input
                                        style={navigationButtonStyle}
                                        type="button"
                                        value="< Prev"
                                        disabled={page === 1}
                                        onClick={() => pagingHandler("sub")}
                                    />
                                    <span style={{ color: "grey", fontSize: "0.85rem" }}>
                                        Showing page {page} out of {loadedData.data.pageCount}
                                    </span>
                                    <input
                                        style={navigationButtonStyle}
                                        type="button"
                                        value="Next >"
                                        disabled={page === loadedData.data.pageCount}
                                        onClick={() => pagingHandler("add")}
                                    />
                                </div>
                                <br />
                                <article className="data-table-wrap">
                                    <table className="data-lists component-data-table cell-content-align-top">
                                        <thead>
                                            <tr>
                                                {header.map((property) => (
                                                    <td
                                                        style={property.canOrder ? clickable : null}
                                                        onClick={() =>
                                                            typeof property === "object" && property.canOrder
                                                                ? orderHandler(property.label)
                                                                : property
                                                        }
                                                    >
                                                        {typeof property === "object"
                                                            ? property.label
                                                            : property}{" "}
                                                        {orderBy.toLowerCase() ===
                                                            property.label.toLowerCase()
                                                            ? orderDirection === "desc"
                                                                ? "↓"
                                                                : "↑"
                                                            : ""}
                                                    </td>
                                                ))}
                                            </tr>
                                        </thead>
                                        {loadedData.data.result.map((row) => (
                                            <tbody>
                                                <tr
                                                    className="hover-listview "
                                                    onClick={() =>
                                                        props.history.push(
                                                            `/provideradmin/${row["providerAdminId"]}`
                                                        )
                                                    }
                                                >
                                                    {header.map((property) => (
                                                        <td>
                                                            <strong className="table-cell-label">
                                                                {typeof property === "object"
                                                                    ? property.label
                                                                    : property}
                                                            </strong>
                                                            {typeof property === "object" ? (
                                                                property.render(row)
                                                            ) : (
                                                                <span>{row[property]}</span>
                                                            )}
                                                        </td>
                                                    ))}
                                                </tr>
                                            </tbody>
                                        ))}
                                    </table>
                                </article>
                            </>
                        )}
                    </div>
                </React.Fragment>
            )}
        </LayoutContext.Consumer>
    );
};

const ProviderAdmin = withRouter(
    withApi(connect(({ user }) => ({ isLoggedIn: !!user }), {})(ProviderAdminInternal))
);

ProviderAdmin.requiresLogin = true;
ProviderAdmin.propTypes = { isLoggedIn: PropTypes.bool };

export default ProviderAdmin;
